module.exports = __webpack_public_path__ + "static/media/gallery_01.92001ecb.png";